export const skillLevels = [
  {
    level: 'New',
    description: 'New to the game of hockey. Still learning basic rules, as well as how to skate and stickhandle.'
  },
  {
    level: 'Okay',
    description: 'Have good knowledge of the rules. Can skate forward and stick-handle with relative ease, but still learning backwards skating and positional hockey.'
  },
  {
    level: 'Good',
    description: 'Comfortable playing with former high school or Division 3 college players or have played high school or Division 3, but have taken a significant break from the game since then and now think you are in more of a pear shape than game shape.'
  },
  {
    level: 'Great',
    description: 'Comfortable playing with current high school or Division 3 college players or have played college (D1) or professionally some time ago.'
  },
  {
    level: 'Elite',
    description: 'Comfortable playing with current junior, Division 1 college or professional players.'
  }
]